<template>
  <section class="vh-100 position-relative">
    <LanguageSwitcher class="position-absolute top-20 right-0 me-0 border-0"></LanguageSwitcher>
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-sm-5 d-sm-flex vh-100 flex-column m-auto h-initial-sm login-left cursor-pointer remove-share"
          style="background-color: #0068b0; padding-top: 12rem"
          @click="goHome"
        >
          <img
            src="../assets/login-logo.svg"
            alt="Login image"
            style="width: 18rem; padding-left: 8.14rem"
            class="login-logo login-section"
          />
          <p
            style="margin-top: 2.6rem; padding-left: 8.14rem"
            class="text-white fw-normal mb-9 fs-28 login-section login-desc"
          >
            {{ $t('login.introduction') }}
          </p>

          <img
            src="../assets/login-left.svg"
            alt="Login"
            style="width: 25.875rem; height: 25.875rem; margin: 0 auto"
            class="login-desc-img"
          />
        </div>

        <div class="col-sm-7 text-black w-100-sm">
          <div class="d-flex align-items-center h-custom-2 px-5 ms-xl-4 pt-5 pt-xl-0">
            <form style="width: 48rem" class="m-auto" @submit.prevent="handleLogin">
              <h1 class="fw-bold mb-0 fs-42" style="color: #131313">
                <span class="login-title">
                  {{ mode === 'register' ? $t('login.newAccount') : $t('login.login') }}
                </span>
              </h1>
              <span
                class="d-inline-block register-tip fw-bold"
                style="
                  margin-top: 0.89rem;
                  color: #0068b0;
                  font-size: 1.33rem;
                  margin-bottom: 3rem;
                  cursor: pointer;
                "
                @click="toggleMode"
              >
                {{ mode === 'register' ? $t('login.back') : $t('login.guideRegister') }}
              </span>

              <div class="position-relative w-100 mb-3">
                <label class="form-label d-flex align-items-center" style="gap: 0.89rem" for="email">
                  <img src="../assets/email.svg" alt="email" style="width: 1.25rem" />
                  <span style="color: #3f4855; font-size: 0.875rem">{{ $t('login.email') }}</span>
                </label>
                <input
                  v-model="email"
                  :disabled="isMailAuth"
                  :placeholder="$t('login.email')"
                  type="email"
                  id="email"
                  class="form-control form-control-lg w-100 text-1d2939"
                  :class="{
                    'opacity-40': isMailAuth
                  }"
                  style="background-color: #f8fbff; border: 1px solid #c9defc"
                />
              </div>

              <div class="position-relative w-100 mb-3">
                <label class="form-label d-flex align-items-center" style="gap: 0.89rem" for="password">
                  <img src="../assets/vpn-key.svg" alt="email" style="width: 1.25rem" />
                  <span style="color: #3f4855; font-size: 0.875rem">{{ $t('login.password') }}</span>
                </label>
                <input
                  v-model="password"
                  :disabled="isMailAuth"
                  :placeholder="$t('login.password')"
                  type="password"
                  id="password"
                  :class="{
                    'opacity-40': isMailAuth
                  }"
                  class="form-control form-control-lg w-100 text-1d2939 password-input"
                  style="background-color: #f8fbff; border: 1px solid #c9defc"
                />
                <div
                  style="width: 1.5rem; height: 1.5rem; right: 1rem; top: 2.55rem"
                  class="position-absolute eye-icon d-none cursor-pointer"
                ></div>
              </div>

              <div class="position-relative w-100 mb-3" v-if="isMailAuth">
                <label
                  class="form-label d-flex align-items-center"
                  style="gap: 0.89rem"
                  for="mailAuthCode"
                >
                  <img
                    src="../assets/icons/verification.svg"
                    alt="verification"
                    style="width: 1.25rem"
                  />
                  <span style="color: #3f4855; font-size: 0.875rem">{{ $t('login.verify') }}</span>
                </label>
                <input
                  v-model="mailAuthCode"
                  @input="onMailAuthCodeInput"
                  type="text"
                  maxlength="6"
                  id="mailAuthCode"
                  :placeholder="$t('login.inputVerify')"
                  class="form-control form-control-lg w-100 text-1d2939"
                  style="background-color: #f8fbff; border: 1px solid #c9defc"
                />
                <div
                  class="fw-bold fs-12 mt-8 text-right d-flex align-items-center justify-content-xxl-between user-select-none flex-wrap justify-content-sm-end"
                >
                  <span
                    class="text-ed3f34 mail-auth-tip"
                    :class="{ 'd-none': !showMailAuthTip }"
                    :style="
                      isMobile()
                        ? {}
                        : {
                            visibility: showMailAuthTip ? 'visible' : 'hidden'
                          }
                    "
                  >
                    {{ $t('login.verifyNumber') }}
                  </span>

                  <div
                    class="text-primary d-flex align-items-center gap-1"
                    :class="{ 'cursor-pointer': timerFinished }"
                    @click="timerFinished && resendMailAuth()"
                  >
                    <span class="opacity-60">{{ $t('login.verifiSend') }}</span>
                    <span class="timer d-flex align-items-center">
                      <span v-if="!timerFinished">{{ timerCount }}s</span>
                      <span v-else>
                        <img :src="iconNext" alt="next" class="icon-14" />
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="register-area" v-if="mode === 'register'">
                <div class="position-relative w-100 mb-3">
                  <label
                    class="form-label d-flex align-items-center"
                    style="gap: 0.89rem"
                    for="confirmed-password"
                  >
                    <img src="../assets/vpn-key.svg" alt="email" style="width: 1.25rem" />
                    <span style="color: #3f4855; font-size: 0.875rem">
                      {{ $t('login.passwordConfirm') }}
                    </span>
                  </label>
                  <input
                    v-model="confirmPassword"
                    type="password"
                    id="confirmed-password"
                    class="form-control form-control-lg w-100 password-input"
                    style="
                      background-color: #f8fbff;
                      border: 1px solid #c9defc;
                      color: #1d2939 !important;
                    "
                    :placeholder="$t('login.passwordConfirm')"
                  />

                  <div
                    style="width: 1.5rem; height: 1.5rem; right: 1rem; top: 2.55rem"
                    class="position-absolute eye-icon d-none cursor-pointer"
                  ></div>
                </div>

                <div class="position-relative w-100 mb-3">
                  <label class="form-label d-flex align-items-center" style="gap: 0.89rem" for="auth-code">
                    <img src="../assets/vpn-key.svg" alt="email" style="width: 1.25rem" />
                    <span style="color: #3f4855; font-size: 0.875rem">
                      {{ $t('login.verifyText') }}
                    </span>
                  </label>
                  <div class="d-flex gap-3">
                    <input
                      v-model="authCode"
                      maxlength="6"
                      type="text"
                      id="auth-code"
                      class="form-control form-control-lg w-75"
                      style="
                        background-color: #f8fbff;
                        border: 1px solid #c9defc;
                        color: #1d2939 !important;
                      "
                      :placeholder="$t('login.inputVerify')"
                    />
                    <button
                      @click.prevent="handleSendRegisterCode"
                      type="button"
                      class="btn btn-outline-primary fw-bold send-auth-code"
                      data-mdb-ripple-color="dark"
                      :disabled="sendCodeLoading"
                      style="
                        padding: 5px 1rem;
                        font-size: 0.875rem;
                        color: #0068b0;
                        border: 1px solid #0068b0;
                        border-radius: 6px;
                      "
                    >
                      {{ $t('login.send') }}
                    </button>
                  </div>
                </div>

                <div class="login-check form-check position-relative d-flex align-items-center">
                  <input
                    v-model="agreeRules"
                    id="register_rules_checkbox"
                    class="form-check-input"
                    type="checkbox"
                  />
                  <label
                    class="form-check-label d-flex align-items-center"
                    for="register_rules_checkbox"
                  >
                    <span v-html="termsHtml"></span>
                  </label>
                </div>
              </div>

              <div class="pt-1">
                <button
                  @click.prevent="handleLogin"
                  class="btn btn-lg btn-block fw-bold text-white login-btn"
                  style="background-color: #0068b0; font-size: 0.875rem; padding: 0.5rem 1rem"
                  type="button"
                  v-if="mode === 'login'"
                  :disabled="loading"
                >
                  {{ isMailAuth ? $t('login.go') : $t('login.login') }}
                </button>
                <button
                  @click.prevent="handleRegister"
                  class="btn btn-lg btn-block text-white register-btn fw-bold"
                  style="background-color: #0068b0; font-size: 0.875rem"
                  type="button"
                  v-else
                  :disabled="loading"
                >
                  {{ $t('login.register') }}
                </button>

                <button
                  @click.prevent="handleResetPassword"
                  class="btn btn-lg btn-block text-white btn-reset-password fw-bold"
                  :class="{ 'd-none': !showResetPasswordBtn }"
                  style="background-color: #0068b0; font-size: 0.875rem"
                  type="button"
                  :disabled="loading"
                >
                  {{ $t('login.resetPassword') }}
                </button>
              </div>

              <span
                class="d-inline-block fw-bold btn-forgot-password"
                style="
                  margin-top: 1.33rem;
                  color: #0068b0;
                  font-size: 0.75rem;
                  margin-bottom: 8.89rem;
                  cursor: pointer;
                "
                v-if="mode !== 'register' && !isMailAuth"
                @click.prevent="handleForgotPassword"
              >
                {{ $t('login.forgetPassword') }}
              </span>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- 重置密码提示 -->
  <div
    class="modal fade"
    id="resetInfoModal"
    tabindex="-1"
    aria-labelledby="resetInfoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" style="max-width: 30rem">
      <div class="modal-content">
        <div
          style="padding: 1.25rem 1.25rem 0.75rem; border-bottom: 1px solid #D5DBE2"
          class="d-flex align-items-center justify-content-between"
        >
          <div
            id="resetInfoModalLabel"
            class="reset-title"
            style="font-weight: 700; color: #1c2124; font-size: 1.125rem"
          >
            {{ $t('common.normalTip') }}
          </div>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            data-mdb-dismiss="modal"
          ></button>
        </div>
        <div style="padding: 1.5rem 1.5rem 2.5rem" class="reset-content">
          {{ $t('login.alert.info') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  nextTick,
  onMounted,
  ref,
  watch,
  watchEffect
} from 'vue'
import LanguageSwitcher from 'src/admin/components/common/LanguageSwitcher.vue'
import i18n from 'src/lang/index.js'
import { isEmail, isMobile, request } from 'scripts/utils.js'
import Toast from 'scripts/toast.js'
import iconNext from '../assets/icons/next.svg'
import { STORAGE_KEY } from 'scripts/consts.js'

const $t = i18n.global.t

const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const authCode = ref('')
const mailAuthCode = ref('')
const mode = ref(location.search.includes('signup=true') ? 'register' : 'login')
const isMailAuth = ref(false)
const timerCount = ref(60)
const timerId = ref(null)
const loading = ref(false)
const agreeRules = ref(false)
const timerFinished = computed(() => timerCount.value <= 0)
const showMailAuthTip = ref(false)
const sendCodeLoading = ref(false)
const forgotPasswordProcessing = ref(false)
const showResetPasswordBtn = ref(false)

const eyeIconEventHandlers = new Map()
const toast = new Toast()
const isValidPassword = (pwd) => /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9%_+\-.]{10,50}$/.test(pwd || '')

const termsHtml = computed(() => {
  const termsText = $t('login.terms')
  return termsText.replace(
    /<link>(.*?)<\/link>/g,
    '<a target="_blank" href="../assets/files/rules.pdf">$1</a>'
  )
})

const startTimer = () => {
  timerCount.value = 60
  if (timerId.value) clearInterval(timerId.value)
  timerId.value = setInterval(() => {
    timerCount.value -= 1
    if (timerCount.value < 0) {
      clearInterval(timerId.value)
    }
  }, 1000)
}

const resendMailAuth = async () => {
  if (!email.value) return
  const res = await request('auth/login_mail_code', { email: email.value }, false)
  if (res?.code === 200) {
    startTimer()
  }
}

const startMailAuth = () => {
  isMailAuth.value = true
  startTimer()
  new Toast().toast('success', $t('login.verifiSent'))
  setTimeout(() => {
    const mailAuthEl = document.getElementById('mailAuthCode')
    if (mailAuthEl) mailAuthEl.focus()
  }, 100)
}

const resetTokens = () => {
  localStorage.removeItem('SCANAT_TOKEN')
  localStorage.removeItem('SCANAT_REFRESH_TOKEN')
  sessionStorage.removeItem('SCANAT_USER_INFO')
  localStorage.removeItem(STORAGE_KEY.LOGIN_TIME)
  sessionStorage.removeItem('customer')
}

const validateMailAuthCode = value => {
  const isSixNumber = value.length === 6 && value.match(/^\d+$/)
  if (isMobile()) {
    showMailAuthTip.value = !isSixNumber
  } else {
    showMailAuthTip.value = !isSixNumber && value.length > 0
  }
  return isSixNumber
}

const handleLogin = async () => {
  if (!email.value || !password.value) {
    toast.toast('danger', $t('login.noEmpty'))
    return
  }
  if (!isEmail(email.value)) {
    toast.toast('danger', $t('login.emailError'))
    return
  }
  if (isMailAuth.value && mailAuthCode.value) {
    if (!validateMailAuthCode(mailAuthCode.value)) {
      toast.toast('danger', $t('login.verifyNumber'))
      return
    }
  }
  loading.value = true
  resetTokens()
  let url = 'auth/login'
  const data = { email: email.value, password: password.value, isFromPortal: true }
  if (isMailAuth.value && mailAuthCode.value) {
    url = 'auth/mail_code_login'
    data.mailCode = mailAuthCode.value
  }
  const res = await request(url, data, false)
  loading.value = false
  if (!res) {
    return
  }
  if (res?.code === 20000) {
    startMailAuth()
    return
  }
  if (res?.code === 200 && res?.data?.refresh_token) {
    const tokenRes = await request(
      'auth/refresh_token',
      { refreshToken: res.data.refresh_token, isFromPortal: true },
      false
    )
    if (tokenRes.code === 200) {
      localStorage.setItem('SCANAT_REFRESH_TOKEN', tokenRes.data.refresh_token)
      localStorage.setItem('SCANAT_TOKEN', tokenRes.data.access_token)
      localStorage.setItem(STORAGE_KEY.LOGIN_TIME, new Date().getTime().toString())
    }
    const userRes =  await request('auth/currentUserInfo', null, true, 'POST', false)
      if(userRes?.code === 200) {
        const userInfo = userRes.data || {}
        if([0, 6].includes(userInfo.userStatus)) {
          localStorage.removeItem('SCANAT_TOKEN')
          localStorage.removeItem('SCANAT_REFRESH_TOKEN')
          toast.toast('warning', $t('error.accountNoAccess'))
          return

        }
      }
    toast.toast('success', $t('login.loginSuccess'), false, {
      callback: () => {
        const modelKey = sessionStorage.getItem('SCANAT_SHARE_KEY')
        const redirectUrl = sessionStorage.getItem('SCANAT_SHARE_LINK')
        if (redirectUrl) {
          window.location.href = redirectUrl
          sessionStorage.removeItem('SCANAT_SHARE_LINK')
        } else if (modelKey) {
          sessionStorage.removeItem('SCANAT_SHARE_KEY')
          window.location.href = `./models.html?${modelKey}`
        } else {
          window.location.href = './landing.html'
        }
      }
    })
  }
}

const handleSendRegisterCode = async () => {
  if (!email.value) {
    toast.toast('danger', $t('login.noEmpty'))
    return
  }
  if (sendCodeLoading.value) return
  sendCodeLoading.value = true
  try {
    const codeRes = await request('auth/register_code', { email: email.value }, false)
    if (codeRes.code === 200) {
      toast.toast('success', $t('login.sent'), false, {
        callback: () => {
          sendCodeLoading.value = false
        }
      })
    } else {
      toast.toast('danger', codeRes.message, false, {
        callback: () => {
          sendCodeLoading.value = false
        }
      })
    }
  } catch (e) {
    toast.toast('danger', e.message, false, {
      callback: () => {
        sendCodeLoading.value = false
      }
    })
  }
}

const handleRegister = async () => {
  if (!email.value || !password.value || !confirmPassword.value || !authCode.value) {
    toast.toast('danger', $t('login.noEmpty'))
    return
  }
  if (!isValidPassword(password.value) || !isValidPassword(confirmPassword.value)) {
    toast.toast('danger', $t('login.passwordTip'))
    return
  }
  if (!isEmail(email.value)) {
    toast.toast('danger', $t('login.emailError'))
    return
  }

  if (!validateMailAuthCode(authCode.value)) {
    toast.toast('danger', $t('login.verifyNumber'))
    return
  }
  
  if (!agreeRules.value) {
    toast.toast('warning', $t('login.termsError'))
    return
  }
  loading.value = true
  const res = await request(
    'auth/portal_register',
    {
      email: email.value,
      password: password.value,
      confirmPassword: confirmPassword.value,
      authCode: authCode.value
    },
    false
  )
  console.log(res, 'res')
  loading.value = false
  if (res?.code === 200) {
    sessionStorage.removeItem('SCANAT_SHARE_LINK')
    toast.toast('success', $t('login.registerSuccess'), false, {
      callback: () => window.location.reload()
    })
  }
}

const handleResetPassword = async () => {
  const res = await request(
    'auth/reset_password',
    {
      email: email.value,
      password: password.value,
      confirmPassword: confirmPassword.value,
      authCode: authCode.value
    },
    false
  )
  if (res?.code === 200) {
    toast.toast('success', $t('login.resetPasswordSuccess'), false, {
      callback: () => {
        window.location.href = '/login.html'
      }
    })
  } else {
    if (res.code === 807) {
      const messageModalEl = document.getElementById('messageModal')
      if (messageModalEl) {
        const titleEl = messageModalEl.querySelector('.title')
        if (titleEl) titleEl.textContent = res.message
        new mdb.Modal(messageModalEl).show()
      }
    }
  }
}

const handleForgotPassword = async () => {
  if (!email.value) {
    toast.toast('danger', $t('login.noEmpty'))
    return
  }
  if (forgotPasswordProcessing.value) return
  forgotPasswordProcessing.value = true
  try {
    const res = await request('auth/sendResetPasswordEmail', { email: email.value }, false)
    if (res?.code === 200) {
      const resetInfoModalEl = document.getElementById('resetInfoModal')
      if (resetInfoModalEl) {
        new mdb.Modal(resetInfoModalEl).show()
      }
    } else if (res?.code === 501) {
      toast.toast('danger', $t('login.forgetPasswordToast'))
    } else if (res?.code === 405) {
      toast.toast('danger', $t('login.emailNone'))
    }
  } finally {
    setTimeout(() => {
      forgotPasswordProcessing.value = false
    }, 300)
  }
}

const toggleMode = () => {
  mode.value = mode.value === 'register' ? 'login' : 'register'
  isMailAuth.value = false
  mailAuthCode.value = ''
  showResetPasswordBtn.value = false
  nextTick(() => {
    setupPasswordEyeIcon()
  })
}

const setupPasswordEyeIcon = () => {
  const passwordEl = document.getElementById('password')
  const confirmPasswordEl = document.getElementById('confirmed-password')
  const eyeIcons = document.querySelectorAll('.eye-icon')

  eyeIcons.forEach((eyeIcon, index) => {
    if (eyeIconEventHandlers.has(eyeIcon)) {
      const handlers = eyeIconEventHandlers.get(eyeIcon)
      eyeIcon.removeEventListener('mouseover', handlers.mouseover)
      eyeIcon.removeEventListener('mouseout', handlers.mouseout)
      eyeIconEventHandlers.delete(eyeIcon)
    }

    const targetInput = index === 0 ? passwordEl : confirmPasswordEl
    if (!targetInput) return

    const mouseoverHandler = () => {
      if (targetInput.type === 'password') {
        targetInput.type = 'text'
      }
    }

    const mouseoutHandler = () => {
      if (targetInput.type === 'text') {
        targetInput.type = 'password'
      }
    }

    eyeIcon.addEventListener('mouseover', mouseoverHandler)
    eyeIcon.addEventListener('mouseout', mouseoutHandler)
    eyeIconEventHandlers.set(eyeIcon, { mouseover: mouseoverHandler, mouseout: mouseoutHandler })
  })
}

const goHome = () => {
  sessionStorage.removeItem('SCANAT_SHARE_LINK')
  window.location.href = '/'
}

watch(mode, () => {
  nextTick(() => {
    setupPasswordEyeIcon()
  })
})

watchEffect(() => {
  document.title = `${mode.value === 'register' ? $t('login.register') : $t('login.login')} Scanat`
})

onMounted(() => {
  const removeShareBtn = document.querySelectorAll('.remove-share')
  removeShareBtn.forEach(btn => {
    btn?.addEventListener('click', () => {
      sessionStorage.removeItem('SCANAT_SHARE_LINK')
    })
  })
  nextTick(() => {
    setupPasswordEyeIcon()
  })
})

const onMailAuthCodeInput = e => {
  const value = e.target?.value || ''
  validateMailAuthCode(value)
}
</script>


